<template>
  <div class="min-h-screen flex flex-col">
    <div class="flex-grow bg-secondary-500">
      <the-header />

      <!-- add content -->
      <router-view />
    </div>
    <the-footer />
  </div>
</template>

<script>
import { version } from '../package.json'

import theHeader from '@/views/globals/header.vue'
import theFooter from '@/views/globals/footer.vue'

export default {
  components: {
    theHeader,
    theFooter
  },

  data() {
    return {
      version,
      refreshing: false,
      registration: null,
      updateExists: false
    }
  },

  created() {
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true })
  },

  methods: {
    showRefreshUI(e) {
      this.registration = e.detail
      this.updateExists = true
    },

    refreshApp() {
      this.updateExists = false
      window.location.reload()
    }
  }
}
</script>
